import { render, staticRenderFns } from "./detail-schedule.vue?vue&type=template&id=e83bda0e&"
import script from "./detail-schedule.vue?vue&type=script&lang=js&"
export * from "./detail-schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports